import useScopes from "../../auth/accessToken/hooks/useScopes";

const useHasAnyOfScopes = (selectedScopes: string[]) => {
    const scopes = useScopes();
    return !!selectedScopes.find((s) => scopes.includes(s));
};

export default useHasAnyOfScopes;
